import CustomTabs from "components/ui/CustomTabs";
import React, { useState } from "react";

const tabs = [
  { value: "new", label: "New" },
  { value: "activated", label: "Activated" },
];

const CasinoFreeSpins = () => {
  const [mainTab, setMainTab] = useState(tabs[0]?.value); // Active main tab

  return (
    <>
      <CustomTabs tabs={tabs} mainTab={mainTab} setMainTab={setMainTab} />
      <div className="py-10 text-center text-white/70 text-[12px]">There are no bonuses for selected type</div>
    </>
  );
};
export default CasinoFreeSpins;
